import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "@/lib/api";

const StoreInfoContext = createContext(null);

const DEFAULTS = { email: "", phone: "", address: "Nash County, NC 27856", socials: [] };

export function StoreInfoProvider({ children }) {
  const [info, setInfo] = useState(DEFAULTS);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setInfo({ ...DEFAULTS, ...data });
    } catch {
      /* keep defaults */
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <StoreInfoContext.Provider value={{ info, refresh, setInfo }}>
      {children}
    </StoreInfoContext.Provider>
  );
}

export const useStoreInfo = () => useContext(StoreInfoContext);
